import React from 'react';
import { Icon } from '../Icon';
import * as S from './IconButton.styled';
const iconSizeMap = {
    large: 20,
    medium: 18,
    small: 16,
    micro: 12,
};
export const IconButton = ({ icon, size = 'medium', variant = 'standard', type = 'button', ...rest }) => {
    return (React.createElement(S.Container, { "$size": size, "$variant": variant, type: type, ...rest },
        React.createElement(Icon, { component: icon, height: iconSizeMap[size] })));
};
